import { compose } from "redux";
import React, { PureComponent } from "react";

import WorkScheduleReportHeaderBase from "features/planner/report/workSchedule/components/WorkScheduleReportHeaderBase";
import WorkScheduleYearReportHeaderWeek from "features/planner/report/workSchedule/components/year/WorkScheduleYearReportHeaderWeek";

class WorkScheduleYearReportHeader extends PureComponent {
  renderDate = (date, index) => {
    return <WorkScheduleYearReportHeaderWeek date={date} key={index} />;
  };

  render() {
    const { dates, title } = this.props;

    return (
      <WorkScheduleReportHeaderBase
        title={title}
        dates={dates}
        renderDate={this.renderDate}
      />
    );
  }
}

export default compose()(WorkScheduleYearReportHeader);
